<template>
    <div class="toSort">
        <v-touch @tap="_tap" tag="a" class="fs-14">{{propText}}</v-touch>
    </div>
</template>

<script>
    export default {
        name: 'indexToSort',
        props: {
            propText: {
                type: String,
                default: '查看全部测评'
            }
        },
        methods: {
            _tap: function () {
                this.$emit('viewMoreSort');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/function';
    .toSort {
        margin: topx(30rem) auto;
        width: topx(670rem);
        /* height: topx(80rem); */
        height: auto;
        box-sizing: border-box;
        text-align: center;
        overflow: hidden;
        background: #fff;
        border: topx(1rem) solid #F0F0F0;
        border-radius: topx(4rem);
        background: #FFFFFF;
        border-radius: topx(10rem);
        height: topx(88rem);
        line-height: topx(88rem);
        a {
            position: relative;
            /* font-size: topx(32rem); */
            line-height: topx(88rem);
            display: inline-block;
            color: #666;
            padding-right: topx(20rem);
            &:before {
                content: '';
                position: absolute;
                right: 0;
                top: 50%;
                transform: translate(0, -50%);
                display: block;
                width: topx(10rem);
                height: topx(20rem);
                background: url('../../assets/icon/icon_arrow_r.svg') no-repeat center;
                background-size: cover;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/show/toSort.vue